<template>
  <footer class="py-4 sm:py-6 px-4">
    <div class="flex flex-wrap items-center justify-center gap-x-3 gap-y-2">
      <!-- Barcode Scanner Status -->
      <div v-if="scanning" class="flex items-center gap-2">
        <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-400"></div>
        <span class="text-gray-400 text-sm sm:text-base font-medium">
          Searching for scanned ID...
        </span>
      </div>
      <button
        @click="reloadKiosk"
        class="text-gray-400 text-sm sm:text-base font-medium hover:text-gray-600 transition"
      >
        Reload
      </button>
      <span class="text-gray-400">·</span>
      <button
        @click="$emit('switch-club')"
        class="text-gray-400 text-sm sm:text-base font-medium hover:text-gray-600 transition"
      >
        Account
      </button>
      <span class="text-gray-400">·</span>
      <button
        @click="$emit('tutorial')"
        class="text-gray-400 text-sm sm:text-base font-medium hover:text-gray-600 transition"
      >
        Tutorial
      </button>
      <span class="text-gray-400">·</span>
      <p class="text-gray-400 text-sm sm:text-base font-medium">
        Powered by WrestlingIQ
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'KioskFooter',
  props: {
    scanning: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['switch-club', 'tutorial'],
  methods: {
    reloadKiosk() {
      window.location.reload();
    },
  },
};
</script>
